<template>
    <div @click="toggle" :class="{'cursor-pointer': !expanded}">
        <div :class="{ 'h-16 sm:h-24 md:h-36': !expanded }" class="overflow-hidden" class2="sm:h-auto sm:overflow-auto">
            <slot />
        </div>

        <div class="z-10 relative mx-auto text-center">
            <div v-if="!expanded" class="z-20 absolute w-full h-12 left-0 bottom-0 reveal-overlay"></div>

            <div :class="{'absolute': !expanded, 'mt-4': expanded}" class="z-30 w-full left-0 bottom-0 mx-auto text-center">
                <button type="button" class="btn btn-xs btn-link px-2 font-semibold bg-white border-gray-400 hover:border-gray-500">
                    <div v-cloak v-show="!expanded">
                        <i class="fad fa-chevron-circle-down fa-lg mr-1"></i>
                        <span>Read More</span>
                    </div>
                    <div v-cloak v-show="expanded">
                        <i class="fad fa-chevron-circle-up fa-lg mr-1"></i>
                        <span>Hide More</span>
                    </div>
                </button>
            </div>
        </div>

        <div class="hidden">
            <i class="fad fa-chevron-circle-down fa-lg mr-1"></i>
            <i class="fad fa-chevron-circle-up fa-lg mr-1"></i>
        </div>
    </div>
</template>

<script>
/**
 * @see https://css-tricks.com/text-fade-read-more/
 * @see https://medium.com/@sdkcodes/quick-vue-how-to-implement-read-more-feature-a116b1ba48a8
 */
export default {
    data: () => ({
        expanded: false
    }),

    created() {},

    methods: {
        toggle() {
            if (this.expanded) {
                return this.collapse();
            } else {
                return this.expand();
            }
        },

        expand() {
            this.expanded = true;
        },

        collapse() {
            this.expanded = false;
        }
    }
}
</script>

<style lang="scss" scoped>
// overlay-bg?
.reveal-overlay {
    // white bottom-top gradient with opacity transparency
    background: linear-gradient(to top, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
}
</style>
